export const extractName = (name: string) => {
  return name
    .split(' ')
    .map(e => e[0])
    .slice(0, 2)
    .join('');
};
